
import React from 'react';
import { ImportantInfoHeader } from './ImportantInfoHeader';


export interface SectionProps {
  title: string;
  isInvalid?: boolean;
  // application: ApplicationType;
}

export interface Section {
  title: string;
  children: React.ReactNode;
  isValid?: () => boolean;
  setTouched?: (touched: boolean) => void;
}

interface Props extends Section {
  // application: ApplicationType
  expanded: boolean;
  checked?: boolean;
  isInvalid?: boolean;
  onExpand?: () => void;
}


export const ImportantInfoSection = (props: Props) => {
  if (props.expanded) {
    return (
      <li className="list-group-item p-0">
        <ImportantInfoHeader
          title={props.title}
          checked={props.checked}
          isInvalid={props.isInvalid}
          onClick={props.onExpand}
        />
        <div className="px-3 pt-3 pb-5">{props.children}</div>
      </li>
    )
  }
  else {
    return (
      <li className="list-group-item p-0"> 
        <ImportantInfoHeader
          title={props.title}
          checked={props.checked}
          isInvalid={props.isInvalid}
          onClick={props.onExpand}
        />
      </li>
    )
  }
}
